
import { BlogPost } from '@/types/blog';
import { content } from './content';

export const weisheitUndExpertisePost: BlogPost = {
  title: 'Wähle weise, mit wem du gehst - Über echte Expertise',
  metaTitle: 'Echte Expertise erkennen: Weisheit vs. Lautstärke',
  date: '10.04.2025',
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: 'Coaching-Philosophie',
  tags: ['Weisheit', 'Expertise', 'Finanzcoaching', 'Lernprozess'],
  excerpt: 'Manche Menschen lehren aus Weisheit, andere nur aus Lautstärke. Wie unterscheidet man, wer wirklich weiß – und wer nur redet? Eine Reflexion über wahre Expertise in einer Welt voller selbsternannter Experten.',
  imageUrl: '/lovable-uploads/9d4eea38-fb49-4c85-896e-793833c8ab6d.png',
  content,
  slug: 'weisheit-und-expertise',
  metaDescription: 'Echte Expertise von Selbstdarstellung unterscheiden. Verschiedene Arten von Wissen und wie Sie die richtigen Berater finden.',
};
